import { inject, Injectable } from '@angular/core';
import { DottedKey } from '../../../../core/field-definitions/entities/field-definition.entity';
import { ExtendedProfileField } from '../../../../core/profiles/entities/extended-profile-field.entity';
import { RecordTypeTranslationService } from '../../../../core/record-types/services/record-type-translation.service';
import { ApiFragment } from '../../../../core/records/entities/api-fragment.class';
import { Cell } from '../../components/cells/_base/table-cell.entity';
import { TextCell } from '../../components/cells/text-cell/text-cell.entity';
import { ColumnWidth } from '../../entities/column-width.entity';
import { ProfileFieldColumnService } from '../base-columns/profile-field-column.service';

@Injectable({ providedIn: 'root' })
export class RecordTypeColumnService extends ProfileFieldColumnService<ApiFragment> {
    protected readonly WIDTH: ColumnWidth = ColumnWidth.WIDE;
    protected readonly DISABLE_SORT: boolean = false;

    private readonly recordTypeTranslationService: RecordTypeTranslationService = inject(RecordTypeTranslationService);

    protected getMapper(profileField: ExtendedProfileField): (item: ApiFragment) => Cell {
        return record => new TextCell(this.translateType(record));
    }

    private translateType(record: ApiFragment): string {
        return this.recordTypeTranslationService.getRecordTypeTranslation(record.getRecordType());
    }

    protected getFieldSelectDottedKeys(profileField: ExtendedProfileField): DottedKey[] {
        return ['Administrative.RecordType'] as DottedKey[];
    }
}
